import type {CrmNodeAction} from 'src/action-creators/crm-node';
import type {CrmNodeState} from 'src/types/crm-node';

import {
  RECEIVE_CRM_NODE_INFO,
  UPDATE_CRM_NODE_INFO,
  RESET_CRM_NODE_STATE,
} from 'src/action-creators/crm-node';
import {CRM_NODE_FIELD_OPTIONS} from 'src/constants/crm-node';

// Derived from the field options so every field resets to '' (keeps reset and
// parse in sync as the field list grows; see parseCrmNode).
const initialState: CrmNodeState = Object.fromEntries(
  CRM_NODE_FIELD_OPTIONS.map(({key}) => [key, '']),
) as CrmNodeState;

export default (
  state: CrmNodeState = initialState,
  action: CrmNodeAction,
): CrmNodeState => {
  switch (action.type) {
    case UPDATE_CRM_NODE_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_CRM_NODE_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CRM_NODE_STATE:
      return {...initialState};
  }
  return state;
};
